import classNames from "classnames";
import { HTMLAttributes } from "react";
import { Text } from "../Formatting";
import styles from "./ToolbarControl.module.scss";

interface ToolbarControlProps extends HTMLAttributes<HTMLElement> {
  label?: string;
  contentsClassName?: string;
}

const ToolbarControl = (props: ToolbarControlProps) => {
  const { label, className, children, contentsClassName, ...elementProps } = props;
  return (
    <Text {...elementProps} className={classNames(styles.root, className)} element="div" variant="xs">
      {label && <strong className={styles.label}>{label}</strong>}
      <div className={classNames(styles.contents, contentsClassName)}>{children}</div>
    </Text>
  );
};

export default ToolbarControl;
